const PRIO_TR = { low: "Düşük", medium: "Orta", high: "Yüksek" };

function nextDayISO(iso) {
  const [y, m, d] = iso.split("-").map(Number);
  const x = new Date(Date.UTC(y, m - 1, d + 1));
  return x.toISOString().slice(0, 10);
}

export function todoBody(todo, contact, account) {
  const lines = [];
  if (todo.description) lines.push(todo.description, "");
  lines.push(`Öncelik: ${PRIO_TR[todo.priority] || "Orta"}`);
  if (contact) lines.push(`İlgili Cari: ${contact.name}`);
  if (account) lines.push(`İlgili Hesap: ${account.name}`);
  lines.push("", "Plasper Finans — Yapılacaklar");
  return lines.join("\n");
}

export function outlookComposeUrl(todo, contact, account) {
  const p = new URLSearchParams({
    path: "/calendar/action/compose",
    rru: "addevent",
    subject: todo.title,
    body: todoBody(todo, contact, account),
    startdt: todo.due_date,
    enddt: nextDayISO(todo.due_date),
    allday: "true",
  });
  return `https://outlook.office.com/calendar/0/deeplink/compose?${p.toString()}`;
}

const esc = (s) => String(s || "").replace(/\\/g, "\\\\").replace(/\n/g, "\\n").replace(/([,;])/g, "\\$1");

function fold(line) {
  const out = [];
  let cur = "";
  for (const ch of line) {
    if (new TextEncoder().encode(cur + ch).length > 73) { out.push(cur); cur = " " + ch; }
    else cur += ch;
  }
  out.push(cur);
  return out.join("\r\n");
}

export function buildICS(entries) {
  const stamp = new Date().toISOString().replace(/[-:]/g, "").replace(/\.\d+Z$/, "Z");
  const lines = ["BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//Plasper Finans//Yapilacaklar//TR", "CALSCALE:GREGORIAN", "METHOD:PUBLISH"];
  for (const { todo, contact, account } of entries) {
    lines.push(
      "BEGIN:VEVENT",
      `UID:${todo.id}@plasper-finans`,
      `DTSTAMP:${stamp}`,
      `DTSTART;VALUE=DATE:${todo.due_date.replace(/-/g, "")}`,
      `DTEND;VALUE=DATE:${nextDayISO(todo.due_date).replace(/-/g, "")}`,
      `SUMMARY:${esc(todo.title)}`,
      `DESCRIPTION:${esc(todoBody(todo, contact, account))}`,
      "TRANSP:TRANSPARENT",
      "END:VEVENT",
    );
  }
  lines.push("END:VCALENDAR");
  return lines.map(fold).join("\r\n") + "\r\n";
}

export function downloadICS(content, filename) {
  const blob = new Blob([content], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(url);
}
